'use client'

import { createContext } from 'react'

export const MeetingsContext = createContext<{
  closeDialog?: (id: string) => void
  openDialog?: (id: string) => void
  addMeetingLink?: (link: string) => void
}>({})
